'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ../~/es-object-atoms/index.js
// module id = 624
// module chunks = 1